import { render, staticRenderFns } from "./ModalChat.vue?vue&type=template&id=3d1a9f74&"
import script from "./ModalChat.vue?vue&type=script&lang=js&"
export * from "./ModalChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports